import React, { useEffect, useState } from 'react';
import PrivateRoute from '../../components/PrivateRoutes';

import Frota from '../../pages/Frota/ListaFrota';
import AddFrota from '../../pages/Frota/AddFrota';
import VisualizarFrota from '../../pages/Frota/VisualizarFrota';
import BDT from '../../pages/Frota/Bdt';
import Listar from '../../pages/Frota/Bdt/listar';
import BdtsAbertos from '../../pages/Frota/Bdt/abertos';
import Multas from '../../pages/Frota/Multas';
import CadastrarMulta from '../../pages/Frota/Multas/Cadastrar';
import ShowVtr from '../../pages/Frota/ShowVtr';
import Auditoria from '../../pages/Frota/Auditoria';
import ContratosFrota from '../../pages/Frota/Contratos';

export default function Add(props) {
  return (
    <>
      <PrivateRoute path="/add-frota" component={AddFrota} />
      <PrivateRoute path="/frota" component={Frota} />
      <PrivateRoute path="/visualizar-frota" component={VisualizarFrota} />
      <PrivateRoute path="/bdt" component={BDT} />
      <PrivateRoute path="/bdt-listar" component={Listar} />
      <PrivateRoute path="/bdts-abertos" component={BdtsAbertos} />
      <PrivateRoute path="/multas" component={Multas} />
      <PrivateRoute path="/multa-cadastrar" component={CadastrarMulta} />
      <PrivateRoute path="/visualiza-vtr/:vtrid" component={ShowVtr} />
      <PrivateRoute path="/auditor-frota" component={Auditoria} />
      <PrivateRoute path="/contratos-frota" component={ContratosFrota} />
    </>
  );
}
